/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Form Question SVG Icons
 */
import { ReactComponent as Address } from "assets/images/icons/questions/address-question.svg";
import { ReactComponent as Checkboxes } from "assets/images/icons/questions/checkbox-question.svg";
import { ReactComponent as DateTime } from "assets/images/icons/questions/date-time-question.svg";
import { ReactComponent as Dropdown } from "assets/images/icons/questions/dropdown-question.svg";
import { ReactComponent as Email } from "assets/images/icons/questions/email-question.svg";
import { ReactComponent as FileUpload } from "assets/images/icons/questions/file-upload-question.svg";
import { ReactComponent as Heading } from "assets/images/icons/questions/heading-question.svg";
import { ReactComponent as InfoBox } from "assets/images/icons/questions/infobox-question.svg";
import { ReactComponent as Location } from "assets/images/icons/questions/location-question.svg";
import { ReactComponent as LongAnswer } from "assets/images/icons/questions/long-answer-question.svg";
import { ReactComponent as MultipleChoice } from "assets/images/icons/questions/multiple-choice-question.svg";
import { ReactComponent as Name } from "assets/images/icons/questions/name-question.svg";
import { ReactComponent as NumericalValue } from "assets/images/icons/questions/numerical-question.svg";
import { ReactComponent as OpinionScale } from "assets/images/icons/questions/opinion-scale-question.svg";
import { ReactComponent as Paragraph } from "assets/images/icons/questions/paragraph-question.svg";
import { ReactComponent as PhoneNumber } from "assets/images/icons/questions/phone-number-question.svg";
import { ReactComponent as QuestionGrid } from "assets/images/icons/questions/grid-question.svg";
import { ReactComponent as QuestionGroup } from "assets/images/icons/questions/group-question.svg";
import { ReactComponent as Rating } from "assets/images/icons/questions/rating-question.svg";
import { ReactComponent as ShortAnswer } from "assets/images/icons/questions/short-answer-question.svg";
import { ReactComponent as WebsiteURL } from "assets/images/icons/questions/url-question.svg";
import { ReactComponent as YesNo } from "assets/images/icons/questions/yes-no-question.svg";
import { ReactComponent as Radio } from "assets/images/icons/questions/radio-question.svg";
import { ReactComponent as Search } from "assets/images/icons/questions/search-question.svg";

const questions = {
    Address,
    ShortAnswer,
    LongAnswer,
    MultipleChoice,
    Dropdown,
    Checkboxes,
    YesNo,
    DateTime,
    Location,
    FileUpload,
    Rating,
    OpinionScale,
    NumericalValue,
    Name,
    Email,
    PhoneNumber,
    WebsiteURL,
    Heading,
    Paragraph,
    InfoBox,
    QuestionGrid,
    QuestionGroup,
    Radio,
    Search,
};
export { questions };
